import React from 'react';
import { useLang } from '../contexts/LanguageContext';
export function SocialProofBar() {
  const {
    t
  } = useLang();
  const contractors = t.socialProof.types;
  return <div className="bg-dark-100 border-y border-white/5 py-6 overflow-hidden" data-id="element-376" data-mp="2erphww3cpfqv">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-377" data-mp="29upbul6i4czr">
        <p className="text-center text-xs font-bold tracking-widest text-gray-500 uppercase mb-4" data-id="element-378" data-mp="25tvivde7c800">
          {t.socialProof.label}
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4" data-id="element-379" data-mp="32h0gq815502d">
          {contractors.map((type, index) => <div key={index} className="flex items-center" data-id="element-380" data-mp="2thwyt7dpmqpg" data-mpi={index}>
              <span className="text-gray-300 font-medium" data-id="element-381" data-mp="2tkj4t2kycy5k">{type}</span>
              {index < contractors.length - 1 && <span className="hidden md:inline-block ml-8 text-gold/30" data-id="element-382" data-mp="1i2zwwwwfg70o">
                  •
                </span>}
            </div>)}
        </div>
      </div>
    </div>;
}